
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skiverleih",
      function () {
        return require("private-next-pages/[region]/[resort]/skiverleih.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skiverleih"])
      });
    }
  